var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 136",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7F9FB4",
    d: "M31.06 103.2L0 135.73h40.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A7D3D",
    d: "M37.14 102.13l9.42 33.6h82.57v-11.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#73BF69",
    d: "M40.8 96.75l88.2 21.18V66.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2D296",
    d: "M44.23 89.05L129 59.53V0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.743c428b4c647a3cf906ef8052c4a23e.svg";
export { ForwardRef as ReactComponent };